<template>
  <v-card>
    <v-container v-if="isTableBusy">
      <v-progress-linear indeterminate></v-progress-linear>
      <div class="d-flex text-h6">{{ loadingText }} </div>
    </v-container>
    <v-container v-if="!isTableBusy && folders.length == 0">
      {{ noDataText }}
    </v-container>
    <v-container v-if="!isTableBusy && searchable">
      <v-text-field
        id="folder_tree__buscar__text"
        name="folder_tree__buscar__text"
        @click.stop.prevent
        v-model="searchMe"
        flat
        hide-details
        clearable
        autofocus
        label="Buscar"
        :clear-icon="icon.close"
        :prepend-icon="icon.search"
        @input="onSearchChange"
        :click:clear="restoreOpens"
      ></v-text-field>
    </v-container>
    <v-treeview
      ref="folderTreeView"
      class="overflow-y-auto"
      :style="{ 'height': '530px' }"
      v-model="tree"
      activatable
      :active="actives"
      return-object
      :item-key="folderItemKey"
      :item-text="folderItemText"
      :dense="dense"
      :open="opens"
      :items="items"
      :search="searchMe"
      @update:active="changeActiveFolder"
      @update:open="changeOpenFolder"
    >
      <template v-slot:prepend="{ item, open }">
        <v-icon
          :size="dense ? '20' : item[folderItemKey] == folderRoot ? '30' : '24'"
          :color="
            item[folderItemKey] == folderRoot ? 'orange' : 'orange lighten-3'
          "
        >
          {{ open ? icon.folderOpen : icon.folder }}
        </v-icon>
      </template>
      <template v-slot:label="{ item }">
        <v-list-item :dense="dense" class="pl-1">
          <v-list-item-content class="py-0">
            <v-list-item-title
              :id="`folder_tree__carpeta__list` + item[folderItemText]"
              v-text="item[folderItemText]"
            ></v-list-item-title>
            <v-list-item-subtitle
              v-if="!dense"
              v-text="item.descripcion"
            ></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action
            v-if="!dense && item[folderItemKey] != folderRoot"
          >
            <v-row>
              <folder-update
                :id="`folder_tree__actualizar__list` + item[folderItemText]"
                :folder="item"
                @onClickUpdate="clickUpdate"
              ></folder-update>
              <folder-delete
                :id="`folder_tree__eliminar__list` + item[folderItemText]"
                :folder="item"
                @onDeleteFolder="getFolders"
              ></folder-delete>
            </v-row>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-treeview>

    <v-dialog
      v-if="!dense"
      v-model="dialogFolderForm"
      persistent
      max-width="900px"
    >
      <v-card>
        <v-card-title>
          <v-col cols="11">
            <span class="headline">Editar Carpeta</span>
          </v-col>
          <v-col cols="1" class="text-right">
            <v-btn icon @click="closeDialogFolderForm">
              <v-icon>{{ icon.close }}</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>

        <v-card-text>
          <folder-form
            :folder="folder"
            @onSuccessActionFolder="successActionFolder"
          >
          </folder-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  mdiClose,
  mdiFolderOpenOutline,
  mdiFolderOutline,
  mdiMagnify
} from '@mdi/js'
import {
  folderStoreData,
  folderStoreActions
} from '../store/folderStoreHelpers'

import FolderUpdate from '@/modules/catalogs/components/FolderUpdate'
import FolderDelete from '@/modules/catalogs/components/FolderDelete'
import FolderForm from '@/modules/catalogs/components/FolderForm'

export default {
  name: 'FolderTree',
  components: {
    FolderUpdate,
    FolderDelete,
    FolderForm
  },
  props: {
    search: {
      type: String,
      default: ''
    },
    dense: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: false
    },
    openRoot: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      icon: {
        close: mdiClose,
        folder: mdiFolderOutline,
        folderOpen: mdiFolderOpenOutline,
        search: mdiMagnify
      },
      tree: [],
      items: [],
      actives: [],
      opens: [],
      opensBackup: [],
      searchMe: '',
      dialogFolderForm: false,
      folder: {}
    }
  },
  created() {
    if (this.folders.length > 0) {
      this.loadData()
    } else {
      this.getFolders()
    }
  },
  computed: {
    ...folderStoreData
  },
  watch: {
    folders() {
      this.loadData()
    },
    search() {
      this.searchMe = this.search
    },
    value() {
      this.setActiveFolder()
    }
  },
  methods: {
    ...folderStoreActions,
    loadData() {
      this.items = Object.assign([], this.folders)
      if (this.openRoot) {
        this.opens.push({ idCarpeta: this.folderRoot })
      }

      this.$nextTick(() => {
        this.setActiveFolder()
      })
    },
    changeActiveFolder(node) {
      if (node.length > 0) {
        this.$emit('onChangeActionFolder', node[0])
      }
    },
    changeOpenFolder(node) {
      this.opens = node
    },
    onSearchChange(text) {
      const textLength = (text || '').length
      if (textLength == 1 && this.opensBackup.length == 0) {
        this.opensBackup = Object.assign([], this.opens)
        this.$refs.folderTreeView.updateAll(true)
      } else if (textLength == 0) {
        this.restoreOpens()
      }
    },
    restoreOpens() {
      this.$refs.folderTreeView.updateAll(false)
      this.opens = Object.assign([], this.opensBackup)
      this.opensBackup = []
    },
    clickUpdate(value) {
      this.folder = value
      this.dialogFolderForm = true
    },
    closeDialogFolderForm() {
      this.dialogFolderForm = false
    },
    successActionFolder() {
      this.closeDialogFolderForm()
      this.getFolders()
    },
    setActiveFolder() {
      let active = this.folderRoot
      if (this.value != null) {
        active = this.value
      }
      this.actives.push({ idCarpeta: active })
    }
  }
}
</script>
